import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TopbarLayout } from "../Topbar/TopbarLayout";
import { SidebarComponent } from "../Sidebar/SidebarComponent";
import { ToastContainerComponent } from "../../Components/Toast/ToastContainerComponent";
import { ConfirmModalComponent } from "../../Components/ConfirmModal/ConfirmModalComponent";

@Component({
  selector: "app-auth-layout",
  standalone: true,
  imports: [RouterOutlet, TopbarLayout, SidebarComponent, ToastContainerComponent, ConfirmModalComponent],
  templateUrl: "./AuthShellLayout.html",
  styleUrl: "./AuthShellLayout.scss",
})
export class AuthShellLayout {}
